module.exports = __webpack_public_path__ + "img/Bild 062.f40d6efa.jpg";